import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Hidden } from "@material-ui/core";
import Advertise from "../../components/Advertise";
import SliderCarousel from "../../components/SliderCarousel";
const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: "green",

    [theme.breakpoints.down("md")]: {
      // backgroundColor: "red",
    },
  },
}));

const Sliders = ({ data }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container>
        {/* <Grid item lg={2}>
          <Advertise data={data.advertise} />
        </Grid> */}
        <Grid item lg={12}>
          <SliderCarousel data={data?.data} />
        </Grid>
      </Grid>
    </div>
  );
};
export default Sliders;
